import { CREATE_BOOK, GET_BOOK, BOOK_REQUEST, DELETE_BOOK, UPDATE_BOOK, BOOK_REQUEST_FAILURE, UPDATE_BOOK_IN_LIST, ADD_BOOK_IN_LIST, DELETE_BOOK_IN_LIST } from "../types";

const initialState = {
    books: [],
    loading: false,
    error: null,
  };

  const bookReducer = (state = initialState, action) => {
    switch (action.type) {
      case BOOK_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_BOOK: {
        return {
          ...state,
          books: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_BOOK:
        return {
          ...state,
          books: [action.payload, ...state.books],
          loading: false,
          error: null
        };
      case UPDATE_BOOK:
        const booksData = state.books.slice(0);
        const uIndex = booksData.findIndex((data) => data.id === action.payload.id);
        booksData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          books: [ ...booksData ],
          loading: false,
          error: null
        };
      case DELETE_BOOK:
        const books = state.books?.slice(0);
        const index = books.findIndex((data) => data.id === action.id);
        if (index > -1) {
            books.splice(index, 1);
        }
        return {
          ...state,
          books: [...books],
          loading: false,
          error: null
        }
      case BOOK_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case UPDATE_BOOK_IN_LIST: {
        const bookId = parseInt(action.payload?.id) || 0;
        const data = action.payload?.data;
        const booksData = state.books?.slice(0) || [];
        
        if (data) {
          if (booksData?.length) {
            const index = booksData.findIndex((val) => val.id === bookId);
            if (index > -1) {
              booksData.splice(index, 1, data);
            }
          }
        }
  
        return {
          ...state,
          books: booksData,
        }
      }
      case ADD_BOOK_IN_LIST: {
        const data = action.payload?.data;
        const booksData = state.books?.slice(0) || [];
        if (data) {
          booksData.unshift(data);
        }
  
        return {
          ...state,
          books: booksData,
        }
      }
      case DELETE_BOOK_IN_LIST: {
        const bookId = parseInt(action.payload?.id) || 0;
        const booksData = state.books?.slice(0) || [];
        if (bookId) {
          if (booksData?.length) {
            const index = booksData.findIndex((val) => val.id === bookId);
            if (index > -1) {
              booksData.splice(index, 1);
            }
          }
        }
  
        return {
          ...state,
          books: booksData,
        }
      }
      default:
        return state;
    }
  };

  export default bookReducer;